// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"f4e25359","453":"8e36eb24"}[chunkId] + ".chunk.js";
};